export const TIMEKEEPING_INTEGRATIONS_ACTION_NOT_FOUND_ERROR_MESSAGE =
  "Timekeeping action not found";

export const DURATION_OF_TIMEKEEPING_ACTION_SUCCESS_MESSAGE_IN_MS = 2.5 * 1000;
